import React from 'react';

import Button from 'components/shared/Buttons/Button/Button';

const Today = ({ goToTodayHandle }) => {
  const goToToday = () => {
    goToTodayHandle(new Date());
  };

  return (
    <Button
      text="Today"
      variant="tertiary"
      size="xs"
      onClick={goToToday}
      data-qa="calendar-today"
    />
  );
};

export default Today;
